// URL half of the session-transfer helpers (server-safe); the SSO cookie helpers are in
// src/client/hooks/SessionTransfer/SessionTransfer.utils.ts.
export const SESSION_TRANSFER_TOKEN_PARAM = 'session_transfer_token';

const RELATIVE_URL_BASE = 'https://relative.invalid';

const isAbsoluteUrl = (urlString: string) => /^https?:\/\//i.test(urlString);

const parseUrl = (urlString: string) => {
  const absolute = isAbsoluteUrl(urlString);
  return { url: new URL(urlString, absolute ? undefined : RELATIVE_URL_BASE), absolute };
};

const serializeUrl = (url: URL, absolute: boolean) =>
  absolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`;

const withTrailingSlash = (url: string) => (url.endsWith('/') ? url : `${url}/`);

export const isAllowedUrlForSessionTransfer = (urlString: string, allowedBaseUrls: readonly string[]): boolean => {
  let parsed: URL;
  try {
    parsed = new URL(urlString);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:') return false;

  const normalized = withTrailingSlash(`${parsed.origin}${parsed.pathname}`);
  return allowedBaseUrls
    .filter((base) => typeof base === 'string' && base.length > 0)
    .map(withTrailingSlash)
    .some((prefix) => normalized.startsWith(prefix));
};

export const appendSessionTransferToken = (
  urlString: string,
  token: string,
  allowedBaseUrls: readonly string[],
): string => {
  try {
    const { url, absolute } = parseUrl(urlString);
    if (absolute && !isAllowedUrlForSessionTransfer(urlString, allowedBaseUrls)) return urlString;

    url.searchParams.set(SESSION_TRANSFER_TOKEN_PARAM, token);
    return serializeUrl(url, absolute);
  } catch {
    return urlString;
  }
};

export const stripSessionTransferToken = (urlString: string): string => {
  try {
    const { url, absolute } = parseUrl(urlString);
    if (!url.searchParams.has(SESSION_TRANSFER_TOKEN_PARAM)) return urlString;

    url.searchParams.delete(SESSION_TRANSFER_TOKEN_PARAM);
    return serializeUrl(url, absolute);
  } catch {
    return urlString;
  }
};
